module.exports = __webpack_public_path__ + "img/shangchuan.908c502c.png";